module.exports = __webpack_public_path__ + "img/page2019-cover.8e2f14f5.jpg";